<template>
  <generic-update :model="model">
    <template v-slot:form="{ error, fetch, item, loading, submit }">
      <place-form
        :with-data="item"
        :error="error"
        :loading="loading"
        @submit="submit"
        @reset="fetch"
      />
    </template>
  </generic-update>
</template>

<script>
import PlaceForm from "./Form"
import model from "./model"

export default {
  components: { PlaceForm },
  data() {
    return {
      model,
      localData: {},
    }
  },
}
</script>
